export const ACTIONS = {
    SET_CONTENT_LOCALE: 'LOCALE/SET_CONTENT_LOCALE',
    RESET_CONTENT_LOCALE: 'LOCALE/RESET_CONTENT_LOCALE',
};

export const CONTENT_LOCALE = 'CONTENT_LOCALE';
export const LOCALE = 'LOCALE';
